module.exports = __webpack_public_path__ + "static/merchants-of-doubt-1b5a2a2ecb401d07768969e8dc4b4022.jpg";